import type { ReactElement } from 'react';
import { useRoleListStore } from "../../controllers/RoleListController";
import { useBaseList, useNavigation } from '../../components/fx';

const Roles = () => {
    const { navigate } = useNavigation();

    const OpenRoleControlMap = (item: any) => {
        let navData = {
            targetRoute: `/rolecontrolmap/${item.roleCode}/${item._id}`
        };
        navigate(navData);
    };

    const renderRoleControlMap = (action: any, row: any) => {
        return <span title="Role Control Map" className="m-right-2 pointer resposnive-button text-primary font-13" onClick={() => OpenRoleControlMap(row)}>
            Role Control Map
        </span>
    }

    const customActionMap: any = {
        rolecontrolmap: renderRoleControlMap
    }

    const { renderList } = useBaseList({ storeHook: useRoleListStore, formRoute: '/role', customActionMap });
    return (
        <>
            {renderList()}
        </>
    );
}

export default Roles;
